<template>
    <div class="pop_full" v-if="isShow">
        <div class="layout_wrap sheet_default_set">
            <div class="content_wrap">
                <div class="header_title">
                    <span class="m_title">{{ $t('reservation_settings.title') }}</span>
                    <a class="close mgl_auto" @click="handlerHideSettingPopup"><v-icon>mdi-close</v-icon> {{ $t('common.close') }}</a>
                </div>
                <div class="h_scroll lgray black_txt">
                    <div class="w_940">
                        <!-- 예약 운영 시간 -->
                        <ReservationOperatingHours/>

                        <!-- AI 예약 설정 -->
                        <ReservationAIManagement v-if="hasAiGroup"/>

                        <!-- 예약건 표시 방식 -->
                        <ReservationDisplayMethod/>
                        
                        <!-- 예약상태 관리 -->
                        <ReservationStatusManagement/>
                        
                        <!-- 프로그램 관리 -->
                        <ReservationProgramManagement/>

                        <!-- 그룹관리 -->
                        <ReservationGroupManagement
                            @groupUpdateDone="groupUpdateDone"/>
                        
                        <!-- 담당자 관리 -->
                        <ReservationColumnManagement
                            :groupUpdateTime="groupUpdateTime"/>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const moment = require('@/util/MPMoment')
import { hasAiGroup } from '../../../sheet-filters'
import ReservationOperatingHours from '../ReservationSettingPopup/Components/ReservationOperatingHours.vue'
import ReservationAIManagement from '../ReservationSettingPopup/Components/ReservationAIManagement.vue'
import ReservationDisplayMethod from '../ReservationSettingPopup/Components/ReservationDisplayMethod.vue'
import ReservationStatusManagement from '../ReservationSettingPopup/Components/ReservationStatusManagement.vue'
import ReservationProgramManagement from './Components/ReservationProgramManagement.vue'
import ReservationGroupManagement from './Components/ReservationGroupManagement.vue'
import ReservationColumnManagement from './Components/ReservationColumnManagement.vue'

export default {
    components: {
        ReservationOperatingHours,
        ReservationDisplayMethod,
        ReservationStatusManagement,
        ReservationProgramManagement,
        ReservationGroupManagement,
        ReservationColumnManagement,
        ReservationAIManagement
    },
    props: {
        isShow: Boolean,
        selectedAreaHelper: Object,
    },
    data() {
        return {
            groupUpdateTime: undefined
        }
    },
    computed: {
        hasAiGroup() {
            return hasAiGroup()
        }
    },
    watch: {
        isShow: {
            immediate: true,
            handler: function(newValue) {
                if (newValue == true) {
                    this.selectedAreaHelper.clearSelectedRange()
                }
            }
        }
    },
    methods: {
        handlerHideSettingPopup() {
            this.$emit('handlerHideSettingPopup')
        },
        groupUpdateDone() {
            this.groupUpdateTime = moment()
        }
    }
}
</script>


<style scoped>
@import '../../../CSS/V2ReservationSetting.css';
</style>